function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import classNames from 'classnames';
import React from 'react';
import Section from './Section';
const styles = require('./MainContent-styles.module.scss');
export default function MainContent({
  size = 'medium',
  centerText,
  className,
  ...props
}) {
  return React.createElement(Section, _extends({
    className: classNames(className, styles.content, styles[size], centerText && styles.centerText)
  }, props));
}